import React from 'react';
import { PANDA_COLORS } from 'shared/panda/panda-theme';

/**
 * The shared panda tokens as `--panda-*` custom properties. Set on whatever
 * element roots a Panda surface (the chat drawer wrapper, the search answer
 * card) so the scss modules under it all inherit them.
 */
export const PANDA_CSS_VARS = Object.fromEntries(
  Object.entries(PANDA_COLORS).map(([name, value]) => [
    `--panda-${name.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`)}`,
    value,
  ]),
) as React.CSSProperties;
